export default class CustomType {}
